<template>
  <div class="exam-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/examline/lineitem"
        ><div class="bread">考试大纲</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="exam-desc">
    <div class="desc-left">
      <ExamLineList :lineList="lineList" />
    </div>
    <div class="desc-right">
      <div class="exam-recom"></div>
      <VideoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { findVideoRecommand } from "@/api/video";
import { findLineList } from "@/api/news";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import VideoRecommend from "../../components/video-recommend.vue";
import ExamLineList from "./components/line-list.vue";
import { ElMessage } from "element-plus";
export default {
  components: { VideoRecommend, ExamLineList },
  setup() {
    const route = useRoute();
    const lineList = ref([]);
    const VideoReCommend = ref([]);
    findLineList(route.query.clID.split(","))
      .then((data) => {
        //console.log(data);
        try {
          lineList.value = data;
        } catch (error) {
          ElMessage({
            message: error.message,
            type: "error",
            plain: true,
          });
        }
      })
      .catch((error) => {
        ElMessage({
          message: error.message,
          type: "error",
          plain: true,
        });
      });

    //这里有两个clID的时候用，分割使其变成数组
    findVideoRecommand(route.query.clID.split(","))
      .then((data) => {
        //console.log(data);
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      })
      .catch((error) => {
        console.log(error);
      });
    return { lineList, VideoReCommend };
  },
};
</script>

<style lang="less" scoped>
.exam-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.exam-desc {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  margin: 0 auto;
  .desc-left {
    width: 850px;
    background: #fefefe;
  }
  .desc-right {
    width: 350px;
    //background: #999;
  }
}
</style>
